import React, { useState } from 'react';

interface SkeletonImageProps {
  src: string;
  alt?: string;
  className?: string;
  imgClassName?: string;
  fallbackSrc?: string;
}

export function SkeletonImage({
  src,
  alt = '',
  className = '',
  imgClassName = 'object-cover',
  fallbackSrc = ''
}: SkeletonImageProps) {
  const [loaded, setLoaded] = useState<boolean>(false);
  const minHeightRemovedClass =
    loaded && className.includes('min-h-')
      ? className.replace(/min-h-\d+/g, '').trim()
      : className;

  return (
    <div className={`relative overflow-hidden ${minHeightRemovedClass}`}>
      {/* Blur placeholder */}
      {fallbackSrc && (
        <img
          src={fallbackSrc}
          alt=""
          aria-hidden="true"
          className={`absolute inset-0 h-full w-full scale-110 blur-2xl transition-opacity duration-300 ${
            loaded ? 'opacity-0' : 'opacity-100'
          } object-cover`}
        />
      )}

      {/* Skeleton shimmer overlay */}
      {!loaded && (
        <div className="absolute inset-0 bg-gray-200">
          <div className="h-full w-full animate-pulse bg-gray-200" />
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200" />
        </div>
      )}

      {/* Full image */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full ${imgClassName} transition-opacity duration-500 ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
